import React from "react";
import Listv3 from "../List/ListV3";
import "./Events.css";

const Events = () => {
  const eventList1 = [
    {
      photo: require("../../Assets/Workshops/mew_movement.jpeg"),
      title: "Mew Movement",
      desc: "MewMovement is an independent art store at SS2, est. in March 2021 by two artists, Mel and Yew. MewMovement aspires to connect people through art and provide a safe space where visitors can express themselves through art and be who they are.",
    },
    {
      photo: require("../../Assets/Workshops/flower_bar.jpeg"),
      title: "Flower Bar",
      desc: "Our flower bar will be handled by Shanice, a talented independent florist. Shanice started her florist journey during 2020 and has been curating stunning bouquets for several events and special occasions since then.",
    },
    {
      photo: require("../../Assets/Workshops/saltyeeth.png"),
      title: "Saltyeeth",
      desc: "Saltyeeth is a certified Tooth Gem artist that provides Semi-permanent tooth jewelry in Malaysia. Est. back in 2021 by Elena Laurel, Saltyeeth is currently one of the leading tooth gem businesses in Malaysia! Their curated set designs include Swarovski Crystals, 18KT Gold Charms, and Opal Charms. Saltyeeth aspires people to realize the possibilities of expressing oneself and creativity through tooth gems.",
    },
    {
      photo: require("../../Assets/Workshops/henna.jpeg"),
      title: "Henna",
      desc: "Established in 2016, EVAH Henna Art Studio 'EVAH' offers traditional, modernised and customised henna body art. Being new in the market, we choose instant henna by Golecha Brand as our main product as it is safe and convenient to use.",
    },
    {
      photo: require("../../Assets/Workshops/Dakwat_KL_tattoo.png"),
      title: "Dakwat KL Tattoo",
      desc: "Thoughts abt tattoos, but are not up for the commitments & expensive payment? We got you covered! Airbrushed temporary tatts with matte finishing that could last up to 7-10 days!",
    },
    {
      photo: require("../../Assets/Workshops/but_honestly.jpeg"),
      title: "But, Honestly",
      desc: "Connect with one another like never before. Learn more about your friends, strangers and even yourself by playing But Honestly! A card game that is made for everyone to play. Learn more at buthonestly.co",
    },
    {
      photo: require("../../Assets/Workshops/DIY_Own_Tshirt.jpeg"),
      title: "DIY Own Tshirt",
      desc: "Collaborating with Taylor’s Music Club, we're DIY-ing merch T-shirts, merging talents for an exciting event, infusing joy and interest for all.",
    },
    {
      photo: '',
      title: "BnF Special Event Mocktail",
      desc: "Excited to collaborate with TMC SE, making memorable moments together.",
    },
    {
      photo: require("../../Assets/Workshops/milo_truck.jpeg"),
      title: "Milo Truck",
      desc: "Milo gives you the energy, you set the goal.",
    },
    {
      photo: require("../../Assets/Workshops/dance_cypher.png"),
      title: "Dance Cypher",
      desc: "Join us at Taylor's Music Club's event to groove and freestyle!",
    },
    {
      photo: require("../../Assets/Workshops/jam_session.jpeg"),
      title: "Outdoor Jam Session",
      desc: "Experience the essence of Music Club.",
    },
    {
      photo: require("../../Assets/Workshops/picnic.jpeg"),
      title: "Picnic + Bonding activities",
      desc: "Food, Friendship, Festival, Fun.",
    },
  ];

  const eventList2 = [
    {
      photo: require("../../Assets/SpecialAppearance/midnight-fusic.png"),
      title: "Midnight Fusic",
      desc: "Hailing from Malaysia, these down-to-earth alt-rockers have conquered global stages, dominated local charts, toured alongside Boys Like Girls, and achieved millions of streams in a mere year. Their music weaves a blend of groovy melancholy, shedding light on pressing youth issues.",
    },
    {
      photo: require("../../Assets/SpecialAppearance/RESORT.png"),
      title: "RESORT",
      desc: "Indie-pop outfit RESORT is no stranger to the scene. Notable for their ever-evolving dynamic showcases, they played their debut festival at Good Vibes Festival 2023 and shared the stage with the likes of Sabrina Carpenter, Daniel Caesar and more. RESORT is Sek Hao Ho, Victor Yee and Kyle Emmanuel.",
    },
    {
      photo: require("../../Assets/SpecialAppearance/jaie.jpeg"),
      title: "JAIE",
      desc: "Since debuting in 2017, Malaysian singer-songwriter Chelsea Chan, aka JAIE, has been captivating audiences worldwide with her enchanting vocals and effortlessly chill tunes about universally relatable experiences. Having begun her musical journey on SoundCloud as a student and fledgling songwriter/beatmaker, the enigmatic JAIE has since gone on to release a slew of indie hits, boasting over 16 million streams across music platforms with a dedicated fan base to match.",
    },
  ];

  return (
    <div className="pt-40 container mx-auto h-full relative event-parent">
      <div
        className="content-aside-container text-white"
        id="specialAppearance"
      >
        <h3 className="mb-7  text-2xl event-list-hd title">
          Duckie Activities
        </h3>
      </div>
      <Listv3 event={eventList1} />
      <div
        className="content-aside-container text-white"
        id="workshops"
      >
        <h3 className="mb-7  text-2xl event-list-hd title">
          Special Appearances
        </h3>
      </div>
      <Listv3 event={eventList2} />
    </div>
  );
};

export default Events;
